var _uploadPDFQuery, _uploadPDFGetViewUrlQuery;

import { graphql, fetchQuery } from 'react-relay';
const pdfUploadUrlQuery = _uploadPDFQuery !== void 0 ? _uploadPDFQuery : _uploadPDFQuery = require("./__generated__/uploadPDFQuery.graphql");
const pdfGetViewUrlQuery = _uploadPDFGetViewUrlQuery !== void 0 ? _uploadPDFGetViewUrlQuery : _uploadPDFGetViewUrlQuery = require("./__generated__/uploadPDFGetViewUrlQuery.graphql");
export async function uploadPdf(environment, pdf) {
  const response = await fetchQuery(environment, pdfUploadUrlQuery, {});
  const url = response.legalTermsUploadUrl.signedUrl.replace(/"/g, '');
  await fetch(url, {
    method: 'PUT',
    body: pdf,
    headers: {
      'content-type': 'application/pdf'
    }
  });
  return response.legalTermsUploadUrl.pdfUniqueName;
}
export async function getPdfViewUrl(environment, relationshipId, pdfUniqueName, filename) {
  return fetchQuery(environment, pdfGetViewUrlQuery, {
    relationshipId: relationshipId ? relationshipId : undefined,
    pdfUniqueName: pdfUniqueName,
    saveAsName: filename
  }).then(response => {
    return response.legalTermsUrl;
  }).catch(() => {// console.log('error trying to query for a legal terms signed URL: ', err);
    // This is commented out because while there's currently no sensible reason for this error to occur, it happens every
    // time we run our tests and we get pointless spam in our prints.
  });
}